export default __webpack_public_path__ + "static/media/Projects.92643eea.svg";